/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {ModuleWithProviders, NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {RouterModule} from "@angular/router";
import {NavigationService} from "./services/navigation.service";
import {NavigationConfig} from "./models/navigation-config";
import {TranslateService} from "@ngx-translate/core";
import * as langs from "../i18n/i18n";

@NgModule({
    imports: [
        CommonModule,
        RouterModule
    ],
    declarations: [],
    exports: [],
    providers: []
})
export class NavigationModule {
    constructor(private translateService: TranslateService) {
        Object.keys(langs).map(lang => {
            translateService.setTranslation(lang, langs[lang], true);
        });
    }

    static forRoot(config: NavigationConfig[], hrefConfig: NonNullable<unknown>, notificationHrefConfig: NonNullable<unknown>): ModuleWithProviders<NavigationModule> {
      NavigationService.setHrefState(hrefConfig);
      NavigationService.setNotificationHrefState(notificationHrefConfig);

      return {
          ngModule: NavigationModule,
          providers: [
                {provide: 'navigation-config', useValue: config, multi: true},
                {provide: 'href-state', useValue: hrefConfig, multi: true},
                {provide: 'notification-href-state', useValue: notificationHrefConfig, multi: true}
          ]
        }
    }

    static forChild(config: NavigationConfig[], hrefConfig: NonNullable<unknown>, notificationHrefConfig: NonNullable<unknown>): ModuleWithProviders<NavigationModule> {

      NavigationService.setHrefState(hrefConfig);
      NavigationService.setNotificationHrefState(notificationHrefConfig);

      return {
            ngModule: NavigationModule,
            providers: [
                {provide: 'navigation-config', useValue: config, multi: true}
            ]
        }
    }
}

